module.exports = __webpack_public_path__ + "img/brand-cases5.3ac6154a.png";